/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  CompleteReportSampleUpload200,
  CompleteReportSampleUploadBody,
  CreateCustomReportBody,
  CreateTemplateInput,
  ExportAsyncCustomReportBody,
  ForbiddenResponse,
  FormatReportSectionInput,
  FormatReportSectionOutput,
  GenerateMediaPreviewRequest,
  GeneratePreviewResponse,
  GenerateTemplatePreviewBody,
  GetReportSamplePartUrl200,
  GetReportSamplePartUrlBody,
  InternalServerErrorResponse,
  MediaPreviewResult,
  NotFoundResponse,
  PreviewResult,
  RawReport,
  RawReportSection,
  RegenerateReportSectionInput,
  Report,
  ReportList,
  ReportSection,
  StartReportSampleUpload200,
  StartReportSampleUploadBody,
  Template,
  TemplateList,
  UnauthorizedResponse,
  UpdateReportSectionInput,
  UpdateTemplateInput,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Retrieves a list of custom report templates for the specified organization from the external SKY Custom Report API
 * @summary Get list of custom report templates
 */
export const getTemplateList = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TemplateList>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetTemplateListQueryKey = (organizationId: string) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates`,
  ] as const;
};

export const getGetTemplateListQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTemplateListQueryKey(organizationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateList>>> = ({
    signal,
  }) => getTemplateList(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplateList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplateList>>
>;
export type GetTemplateListQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateList>>,
          TError,
          Awaited<ReturnType<typeof getTemplateList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateList>>,
          TError,
          Awaited<ReturnType<typeof getTemplateList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get list of custom report templates
 */

export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateListQueryOptions(organizationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a custom report template via the external SKY Custom Report API
 * @summary Create a custom report template
 */
export const createTemplate = (
  organizationId: string,
  createTemplateInput: CreateTemplateInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Template>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTemplateInput,
      signal,
    },
    options
  );
};

export const getCreateTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    { organizationId: string; data: CreateTemplateInput },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { organizationId: string; data: CreateTemplateInput },
  TContext
> => {
  const mutationKey = ["createTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTemplate>>,
    { organizationId: string; data: CreateTemplateInput }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return createTemplate(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTemplate>>
>;
export type CreateTemplateMutationBody = CreateTemplateInput;
export type CreateTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a custom report template
 */
export const useCreateTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTemplate>>,
      TError,
      { organizationId: string; data: CreateTemplateInput },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { organizationId: string; data: CreateTemplateInput },
  TContext
> => {
  return useMutation(getCreateTemplateMutationOptions(options), queryClient);
};
/**
 * Retrieves a custom report template by ID from the external SKY Custom Report API
 * @summary Get a custom report template by ID
 */
export const getTemplate = (
  organizationId: string,
  templateId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Template>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetTemplateQueryKey = (
  organizationId: string,
  templateId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}`,
  ] as const;
};

export const getGetTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTemplateQueryKey(organizationId, templateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({
    signal,
  }) => getTemplate(organizationId, templateId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplate>>
>;
export type GetTemplateQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report template by ID
 */

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateQueryOptions(
    organizationId,
    templateId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates a custom report template by ID via the external SKY Custom Report API
 * @summary Update a custom report template by ID
 */
export const updateTemplate = (
  organizationId: string,
  templateId: string,
  updateTemplateInput: UpdateTemplateInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Template>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateTemplateInput,
      signal,
    },
    options
  );
};

export const getUpdateTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTemplate>>,
    TError,
    { organizationId: string; templateId: string; data: UpdateTemplateInput },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { organizationId: string; templateId: string; data: UpdateTemplateInput },
  TContext
> => {
  const mutationKey = ["updateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTemplate>>,
    { organizationId: string; templateId: string; data: UpdateTemplateInput }
  > = (props) => {
    const { organizationId, templateId, data } = props ?? {};

    return updateTemplate(organizationId, templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTemplate>>
>;
export type UpdateTemplateMutationBody = UpdateTemplateInput;
export type UpdateTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update a custom report template by ID
 */
export const useUpdateTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTemplate>>,
      TError,
      { organizationId: string; templateId: string; data: UpdateTemplateInput },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { organizationId: string; templateId: string; data: UpdateTemplateInput },
  TContext
> => {
  return useMutation(getUpdateTemplateMutationOptions(options), queryClient);
};
/**
 * Deletes a custom report template by ID via the external SKY Custom Report API
 * @summary Delete a custom report template by ID
 */
export const deleteTemplate = (
  organizationId: string,
  templateId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplate>>,
    TError,
    { organizationId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  const mutationKey = ["deleteTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTemplate>>,
    { organizationId: string; templateId: string }
  > = (props) => {
    const { organizationId, templateId } = props ?? {};

    return deleteTemplate(organizationId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTemplate>>
>;

export type DeleteTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Delete a custom report template by ID
 */
export const useDeleteTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTemplate>>,
      TError,
      { organizationId: string; templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  return useMutation(getDeleteTemplateMutationOptions(options), queryClient);
};
/**
 * Set a template as the default for its organization. Other templates will be unset as default.
 * @summary Set template as default
 */
export const setDefaultTemplate = (
  organizationId: string,
  templateId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}/default`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getSetDefaultTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDefaultTemplate>>,
    TError,
    { organizationId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDefaultTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  const mutationKey = ["setDefaultTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDefaultTemplate>>,
    { organizationId: string; templateId: string }
  > = (props) => {
    const { organizationId, templateId } = props ?? {};

    return setDefaultTemplate(organizationId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetDefaultTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof setDefaultTemplate>>
>;

export type SetDefaultTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Set template as default
 */
export const useSetDefaultTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setDefaultTemplate>>,
      TError,
      { organizationId: string; templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setDefaultTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  return useMutation(
    getSetDefaultTemplateMutationOptions(options),
    queryClient
  );
};
/**
 * Triggers generation of a sample report using fictional data for the given template. Returns a previewId for polling.
 * @summary Generate a preview report from a template
 */
export const generateTemplatePreview = (
  organizationId: string,
  templateId: string,
  generateTemplatePreviewBody?: GenerateTemplatePreviewBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GeneratePreviewResponse>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}/preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateTemplatePreviewBody,
      signal,
    },
    options
  );
};

export const getGenerateTemplatePreviewMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateTemplatePreview>>,
    TError,
    {
      organizationId: string;
      templateId: string;
      data: GenerateTemplatePreviewBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateTemplatePreview>>,
  TError,
  {
    organizationId: string;
    templateId: string;
    data: GenerateTemplatePreviewBody;
  },
  TContext
> => {
  const mutationKey = ["generateTemplatePreview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateTemplatePreview>>,
    {
      organizationId: string;
      templateId: string;
      data: GenerateTemplatePreviewBody;
    }
  > = (props) => {
    const { organizationId, templateId, data } = props ?? {};

    return generateTemplatePreview(
      organizationId,
      templateId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateTemplatePreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateTemplatePreview>>
>;
export type GenerateTemplatePreviewMutationBody = GenerateTemplatePreviewBody;
export type GenerateTemplatePreviewMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Generate a preview report from a template
 */
export const useGenerateTemplatePreview = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateTemplatePreview>>,
      TError,
      {
        organizationId: string;
        templateId: string;
        data: GenerateTemplatePreviewBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof generateTemplatePreview>>,
  TError,
  {
    organizationId: string;
    templateId: string;
    data: GenerateTemplatePreviewBody;
  },
  TContext
> => {
  return useMutation(
    getGenerateTemplatePreviewMutationOptions(options),
    queryClient
  );
};
/**
 * Polls for the result of a previously triggered preview generation. Returns status and content when completed.
 * @summary Get the result of a preview generation
 */
export const getTemplatePreview = (
  organizationId: string,
  templateId: string,
  previewId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PreviewResult>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}/preview/${previewId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetTemplatePreviewQueryKey = (
  organizationId: string,
  templateId: string,
  previewId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/${templateId}/preview/${previewId}`,
  ] as const;
};

export const getGetTemplatePreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplatePreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplatePreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTemplatePreviewQueryKey(organizationId, templateId, previewId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTemplatePreview>>
  > = ({ signal }) =>
    getTemplatePreview(
      organizationId,
      templateId,
      previewId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && templateId && previewId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplatePreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplatePreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplatePreview>>
>;
export type GetTemplatePreviewQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetTemplatePreview<
  TData = Awaited<ReturnType<typeof getTemplatePreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  previewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplatePreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplatePreview>>,
          TError,
          Awaited<ReturnType<typeof getTemplatePreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplatePreview<
  TData = Awaited<ReturnType<typeof getTemplatePreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplatePreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplatePreview>>,
          TError,
          Awaited<ReturnType<typeof getTemplatePreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplatePreview<
  TData = Awaited<ReturnType<typeof getTemplatePreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplatePreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the result of a preview generation
 */

export function useGetTemplatePreview<
  TData = Awaited<ReturnType<typeof getTemplatePreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplatePreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplatePreviewQueryOptions(
    organizationId,
    templateId,
    previewId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Triggers generation of a media preview from a report sample source string. Returns a previewId for polling.
 * @summary Generate a media preview from a report sample source
 */
export const generateMediaPreview = (
  organizationId: string,
  generateMediaPreviewRequest: GenerateMediaPreviewRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GeneratePreviewResponse>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/media-preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateMediaPreviewRequest,
      signal,
    },
    options
  );
};

export const getGenerateMediaPreviewMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMediaPreview>>,
    TError,
    { organizationId: string; data: GenerateMediaPreviewRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateMediaPreview>>,
  TError,
  { organizationId: string; data: GenerateMediaPreviewRequest },
  TContext
> => {
  const mutationKey = ["generateMediaPreview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateMediaPreview>>,
    { organizationId: string; data: GenerateMediaPreviewRequest }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return generateMediaPreview(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateMediaPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateMediaPreview>>
>;
export type GenerateMediaPreviewMutationBody = GenerateMediaPreviewRequest;
export type GenerateMediaPreviewMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Generate a media preview from a report sample source
 */
export const useGenerateMediaPreview = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateMediaPreview>>,
      TError,
      { organizationId: string; data: GenerateMediaPreviewRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof generateMediaPreview>>,
  TError,
  { organizationId: string; data: GenerateMediaPreviewRequest },
  TContext
> => {
  return useMutation(
    getGenerateMediaPreviewMutationOptions(options),
    queryClient
  );
};
/**
 * Polls for the result of a previously triggered media preview generation. Returns status and content when completed.
 * @summary Get the result of a media preview generation
 */
export const getMediaPreview = (
  organizationId: string,
  previewId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MediaPreviewResult>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/media-preview/${previewId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetMediaPreviewQueryKey = (
  organizationId: string,
  previewId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/media-preview/${previewId}`,
  ] as const;
};

export const getGetMediaPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getMediaPreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMediaPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMediaPreviewQueryKey(organizationId, previewId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaPreview>>> = ({
    signal,
  }) => getMediaPreview(organizationId, previewId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && previewId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMediaPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMediaPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMediaPreview>>
>;
export type GetMediaPreviewQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetMediaPreview<
  TData = Awaited<ReturnType<typeof getMediaPreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  previewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMediaPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaPreview>>,
          TError,
          Awaited<ReturnType<typeof getMediaPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMediaPreview<
  TData = Awaited<ReturnType<typeof getMediaPreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMediaPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaPreview>>,
          TError,
          Awaited<ReturnType<typeof getMediaPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMediaPreview<
  TData = Awaited<ReturnType<typeof getMediaPreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMediaPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the result of a media preview generation
 */

export function useGetMediaPreview<
  TData = Awaited<ReturnType<typeof getMediaPreview>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  previewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMediaPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMediaPreviewQueryOptions(
    organizationId,
    previewId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Retrieves list of custom reports for a case with calculated statuses based on snapshot information
 * @summary List custom reports by case ID
 */
export const listCustomReportsByCase = (
  organizationId: string,
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportList>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getListCustomReportsByCaseQueryKey = (
  organizationId: string,
  projectId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports`,
  ] as const;
};

export const getListCustomReportsByCaseQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCustomReportsByCaseQueryKey(organizationId, projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomReportsByCase>>
  > = ({ signal }) =>
    listCustomReportsByCase(organizationId, projectId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomReportsByCase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCustomReportsByCaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomReportsByCase>>
>;
export type ListCustomReportsByCaseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomReportsByCase>>,
          TError,
          Awaited<ReturnType<typeof listCustomReportsByCase>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomReportsByCase>>,
          TError,
          Awaited<ReturnType<typeof listCustomReportsByCase>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List custom reports by case ID
 */

export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCustomReportsByCaseQueryOptions(
    organizationId,
    projectId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a custom report for a case using the provided template. Accepts idempotencyKey and templateId to generate the report asynchronously.

 * @summary Create a custom report for a case
 */
export const createCustomReport = (
  organizationId: string,
  projectId: string,
  createCustomReportBody: CreateCustomReportBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Report>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomReportBody,
      signal,
    },
    options
  );
};

export const getCreateCustomReportMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomReport>>,
    TError,
    { organizationId: string; projectId: string; data: CreateCustomReportBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomReport>>,
  TError,
  { organizationId: string; projectId: string; data: CreateCustomReportBody },
  TContext
> => {
  const mutationKey = ["createCustomReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomReport>>,
    { organizationId: string; projectId: string; data: CreateCustomReportBody }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return createCustomReport(organizationId, projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomReport>>
>;
export type CreateCustomReportMutationBody = CreateCustomReportBody;
export type CreateCustomReportMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a custom report for a case
 */
export const useCreateCustomReport = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCustomReport>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: CreateCustomReportBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCustomReport>>,
  TError,
  { organizationId: string; projectId: string; data: CreateCustomReportBody },
  TContext
> => {
  return useMutation(
    getCreateCustomReportMutationOptions(options),
    queryClient
  );
};
/**
 * Retrieves a custom report by ID with section metadata only (id, order, title, status). Full section content is fetched separately via getReportSection.
 * @summary Get a custom report by ID
 */
export const getCustomReport = (
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Report>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetCustomReportQueryKey = (
  organizationId: string,
  projectId: string,
  reportId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}`,
  ] as const;
};

export const getGetCustomReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomReportQueryKey(organizationId, projectId, reportId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomReport>>> = ({
    signal,
  }) =>
    getCustomReport(
      organizationId,
      projectId,
      reportId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && reportId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomReport>>
>;
export type GetCustomReportQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getCustomReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getCustomReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report by ID
 */

export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomReportQueryOptions(
    organizationId,
    projectId,
    reportId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Retrieves a custom report section by ID from the external SKY Custom Report API
 * @summary Get a custom report section by ID
 */
export const getReportSection = (
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportSection>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/sections/${reportSectionId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetReportSectionQueryKey = (
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/sections/${reportSectionId}`,
  ] as const;
};

export const getGetReportSectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReportSectionQueryKey(
      organizationId,
      projectId,
      reportId,
      reportSectionId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportSection>>
  > = ({ signal }) =>
    getReportSection(
      organizationId,
      projectId,
      reportId,
      reportSectionId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && reportId && reportSectionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportSection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportSectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportSection>>
>;
export type GetReportSectionQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportSection>>,
          TError,
          Awaited<ReturnType<typeof getReportSection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportSection>>,
          TError,
          Awaited<ReturnType<typeof getReportSection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report section by ID
 */

export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReportSectionQueryOptions(
    organizationId,
    projectId,
    reportId,
    reportSectionId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates the content of a custom report section manually
 * @summary Update a custom report section content
 */
export const updateReportSection = (
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  updateReportSectionInput: UpdateReportSectionInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportSection>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/sections/${reportSectionId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateReportSectionInput,
      signal,
    },
    options
  );
};

export const getUpdateReportSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReportSection>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      reportSectionId: string;
      data: UpdateReportSectionInput;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReportSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    reportSectionId: string;
    data: UpdateReportSectionInput;
  },
  TContext
> => {
  const mutationKey = ["updateReportSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReportSection>>,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      reportSectionId: string;
      data: UpdateReportSectionInput;
    }
  > = (props) => {
    const { organizationId, projectId, reportId, reportSectionId, data } =
      props ?? {};

    return updateReportSection(
      organizationId,
      projectId,
      reportId,
      reportSectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReportSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReportSection>>
>;
export type UpdateReportSectionMutationBody = UpdateReportSectionInput;
export type UpdateReportSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update a custom report section content
 */
export const useUpdateReportSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateReportSection>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        reportId: string;
        reportSectionId: string;
        data: UpdateReportSectionInput;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateReportSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    reportSectionId: string;
    data: UpdateReportSectionInput;
  },
  TContext
> => {
  return useMutation(
    getUpdateReportSectionMutationOptions(options),
    queryClient
  );
};
/**
 * Retrieves a custom report by ID with sections containing rawContent (unprocessed) instead of content
 * @summary Get a custom report with raw section content
 */
export const getRawCustomReport = (
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RawReport>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/raw`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetRawCustomReportQueryKey = (
  organizationId: string,
  projectId: string,
  reportId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/raw`,
  ] as const;
};

export const getGetRawCustomReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getRawCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRawCustomReportQueryKey(organizationId, projectId, reportId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRawCustomReport>>
  > = ({ signal }) =>
    getRawCustomReport(
      organizationId,
      projectId,
      reportId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && reportId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRawCustomReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRawCustomReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRawCustomReport>>
>;
export type GetRawCustomReportQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetRawCustomReport<
  TData = Awaited<ReturnType<typeof getRawCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawCustomReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRawCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getRawCustomReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRawCustomReport<
  TData = Awaited<ReturnType<typeof getRawCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawCustomReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRawCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getRawCustomReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRawCustomReport<
  TData = Awaited<ReturnType<typeof getRawCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report with raw section content
 */

export function useGetRawCustomReport<
  TData = Awaited<ReturnType<typeof getRawCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRawCustomReportQueryOptions(
    organizationId,
    projectId,
    reportId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Validates the request, fetches report data, and triggers an async Lambda to generate the file. The result is delivered by email.
 * @summary Asynchronously export a custom report to PDF or DOCX
 */
export const exportAsyncCustomReport = (
  organizationId: string,
  projectId: string,
  reportId: string,
  exportAsyncCustomReportBody: ExportAsyncCustomReportBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/export/async`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: exportAsyncCustomReportBody,
      signal,
    },
    options
  );
};

export const getExportAsyncCustomReportMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAsyncCustomReport>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      data: ExportAsyncCustomReportBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAsyncCustomReport>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    data: ExportAsyncCustomReportBody;
  },
  TContext
> => {
  const mutationKey = ["exportAsyncCustomReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAsyncCustomReport>>,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      data: ExportAsyncCustomReportBody;
    }
  > = (props) => {
    const { organizationId, projectId, reportId, data } = props ?? {};

    return exportAsyncCustomReport(
      organizationId,
      projectId,
      reportId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAsyncCustomReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAsyncCustomReport>>
>;
export type ExportAsyncCustomReportMutationBody = ExportAsyncCustomReportBody;
export type ExportAsyncCustomReportMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Asynchronously export a custom report to PDF or DOCX
 */
export const useExportAsyncCustomReport = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof exportAsyncCustomReport>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        reportId: string;
        data: ExportAsyncCustomReportBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof exportAsyncCustomReport>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    data: ExportAsyncCustomReportBody;
  },
  TContext
> => {
  return useMutation(
    getExportAsyncCustomReportMutationOptions(options),
    queryClient
  );
};
/**
 * Retrieves a custom report section by ID with rawContent (unprocessed) instead of content
 * @summary Get a custom report section with raw content
 */
export const getRawReportSection = (
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RawReportSection>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/sections/${reportSectionId}/raw`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetRawReportSectionQueryKey = (
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/sections/${reportSectionId}/raw`,
  ] as const;
};

export const getGetRawReportSectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getRawReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRawReportSectionQueryKey(
      organizationId,
      projectId,
      reportId,
      reportSectionId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRawReportSection>>
  > = ({ signal }) =>
    getRawReportSection(
      organizationId,
      projectId,
      reportId,
      reportSectionId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && reportId && reportSectionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRawReportSection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRawReportSectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRawReportSection>>
>;
export type GetRawReportSectionQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetRawReportSection<
  TData = Awaited<ReturnType<typeof getRawReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawReportSection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRawReportSection>>,
          TError,
          Awaited<ReturnType<typeof getRawReportSection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRawReportSection<
  TData = Awaited<ReturnType<typeof getRawReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawReportSection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRawReportSection>>,
          TError,
          Awaited<ReturnType<typeof getRawReportSection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRawReportSection<
  TData = Awaited<ReturnType<typeof getRawReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report section with raw content
 */

export function useGetRawReportSection<
  TData = Awaited<ReturnType<typeof getRawReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRawReportSectionQueryOptions(
    organizationId,
    projectId,
    reportId,
    reportSectionId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Formats the markdown content of a report section using AI. Accepts optional instructions for how to format the text.
 * @summary Format a custom report section content
 */
export const formatReportSection = (
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  formatReportSectionInput: FormatReportSectionInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<FormatReportSectionOutput>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/sections/${reportSectionId}/format`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: formatReportSectionInput,
      signal,
    },
    options
  );
};

export const getFormatReportSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formatReportSection>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      reportSectionId: string;
      data: FormatReportSectionInput;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof formatReportSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    reportSectionId: string;
    data: FormatReportSectionInput;
  },
  TContext
> => {
  const mutationKey = ["formatReportSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formatReportSection>>,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      reportSectionId: string;
      data: FormatReportSectionInput;
    }
  > = (props) => {
    const { organizationId, projectId, reportId, reportSectionId, data } =
      props ?? {};

    return formatReportSection(
      organizationId,
      projectId,
      reportId,
      reportSectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type FormatReportSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof formatReportSection>>
>;
export type FormatReportSectionMutationBody = FormatReportSectionInput;
export type FormatReportSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Format a custom report section content
 */
export const useFormatReportSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formatReportSection>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        reportId: string;
        reportSectionId: string;
        data: FormatReportSectionInput;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof formatReportSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    reportSectionId: string;
    data: FormatReportSectionInput;
  },
  TContext
> => {
  return useMutation(
    getFormatReportSectionMutationOptions(options),
    queryClient
  );
};
/**
 * Regenerates a specific section of a custom report asynchronously. Requires idempotencyKey to ensure idempotent operations.
 * @summary Regenerate a custom report section
 */
export const regenerateSection = (
  organizationId: string,
  projectId: string,
  reportId: string,
  reportSectionId: string,
  regenerateReportSectionInput: RegenerateReportSectionInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportSection>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/reports/${reportId}/sections/${reportSectionId}/regenerate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: regenerateReportSectionInput,
      signal,
    },
    options
  );
};

export const getRegenerateSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSection>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      reportSectionId: string;
      data: RegenerateReportSectionInput;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    reportSectionId: string;
    data: RegenerateReportSectionInput;
  },
  TContext
> => {
  const mutationKey = ["regenerateSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateSection>>,
    {
      organizationId: string;
      projectId: string;
      reportId: string;
      reportSectionId: string;
      data: RegenerateReportSectionInput;
    }
  > = (props) => {
    const { organizationId, projectId, reportId, reportSectionId, data } =
      props ?? {};

    return regenerateSection(
      organizationId,
      projectId,
      reportId,
      reportSectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateSection>>
>;
export type RegenerateSectionMutationBody = RegenerateReportSectionInput;
export type RegenerateSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Regenerate a custom report section
 */
export const useRegenerateSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateSection>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        reportId: string;
        reportSectionId: string;
        data: RegenerateReportSectionInput;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    reportId: string;
    reportSectionId: string;
    data: RegenerateReportSectionInput;
  },
  TContext
> => {
  return useMutation(getRegenerateSectionMutationOptions(options), queryClient);
};
/**
 * Starts a multipart upload for a report sample file that will be used to generate a template
 * @summary Initiate S3 multipart upload for report sample
 */
export const startReportSampleUpload = (
  organizationId: string,
  uploadId: string,
  startReportSampleUploadBody: StartReportSampleUploadBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<StartReportSampleUpload200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/upload/${uploadId}/start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startReportSampleUploadBody,
      signal,
    },
    options
  );
};

export const getStartReportSampleUploadMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startReportSampleUpload>>,
    TError,
    {
      organizationId: string;
      uploadId: string;
      data: StartReportSampleUploadBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: StartReportSampleUploadBody;
  },
  TContext
> => {
  const mutationKey = ["startReportSampleUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startReportSampleUpload>>,
    {
      organizationId: string;
      uploadId: string;
      data: StartReportSampleUploadBody;
    }
  > = (props) => {
    const { organizationId, uploadId, data } = props ?? {};

    return startReportSampleUpload(
      organizationId,
      uploadId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type StartReportSampleUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof startReportSampleUpload>>
>;
export type StartReportSampleUploadMutationBody = StartReportSampleUploadBody;
export type StartReportSampleUploadMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Initiate S3 multipart upload for report sample
 */
export const useStartReportSampleUpload = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startReportSampleUpload>>,
      TError,
      {
        organizationId: string;
        uploadId: string;
        data: StartReportSampleUploadBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof startReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: StartReportSampleUploadBody;
  },
  TContext
> => {
  return useMutation(
    getStartReportSampleUploadMutationOptions(options),
    queryClient
  );
};
/**
 * Generates a presigned URL for uploading a specific part of the report sample multipart upload
 * @summary Get a presigned URL for a specific multipart part of report sample
 */
export const getReportSamplePartUrl = (
  organizationId: string,
  uploadId: string,
  getReportSamplePartUrlBody: GetReportSamplePartUrlBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetReportSamplePartUrl200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/upload/${uploadId}/part-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getReportSamplePartUrlBody,
      signal,
    },
    options
  );
};

export const getGetReportSamplePartUrlMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getReportSamplePartUrl>>,
    TError,
    {
      organizationId: string;
      uploadId: string;
      data: GetReportSamplePartUrlBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getReportSamplePartUrl>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: GetReportSamplePartUrlBody;
  },
  TContext
> => {
  const mutationKey = ["getReportSamplePartUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getReportSamplePartUrl>>,
    {
      organizationId: string;
      uploadId: string;
      data: GetReportSamplePartUrlBody;
    }
  > = (props) => {
    const { organizationId, uploadId, data } = props ?? {};

    return getReportSamplePartUrl(
      organizationId,
      uploadId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetReportSamplePartUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getReportSamplePartUrl>>
>;
export type GetReportSamplePartUrlMutationBody = GetReportSamplePartUrlBody;
export type GetReportSamplePartUrlMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Get a presigned URL for a specific multipart part of report sample
 */
export const useGetReportSamplePartUrl = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getReportSamplePartUrl>>,
      TError,
      {
        organizationId: string;
        uploadId: string;
        data: GetReportSamplePartUrlBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getReportSamplePartUrl>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: GetReportSamplePartUrlBody;
  },
  TContext
> => {
  return useMutation(
    getGetReportSamplePartUrlMutationOptions(options),
    queryClient
  );
};
/**
 * Completes the multipart upload for a report sample and triggers template generation in the custom reports service
 * @summary Complete S3 multipart upload for report sample and generate template
 */
export const completeReportSampleUpload = (
  organizationId: string,
  uploadId: string,
  completeReportSampleUploadBody: CompleteReportSampleUploadBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CompleteReportSampleUpload200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/report-templates/upload/${uploadId}/complete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: completeReportSampleUploadBody,
      signal,
    },
    options
  );
};

export const getCompleteReportSampleUploadMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeReportSampleUpload>>,
    TError,
    {
      organizationId: string;
      uploadId: string;
      data: CompleteReportSampleUploadBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: CompleteReportSampleUploadBody;
  },
  TContext
> => {
  const mutationKey = ["completeReportSampleUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeReportSampleUpload>>,
    {
      organizationId: string;
      uploadId: string;
      data: CompleteReportSampleUploadBody;
    }
  > = (props) => {
    const { organizationId, uploadId, data } = props ?? {};

    return completeReportSampleUpload(
      organizationId,
      uploadId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteReportSampleUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeReportSampleUpload>>
>;
export type CompleteReportSampleUploadMutationBody =
  CompleteReportSampleUploadBody;
export type CompleteReportSampleUploadMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Complete S3 multipart upload for report sample and generate template
 */
export const useCompleteReportSampleUpload = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeReportSampleUpload>>,
      TError,
      {
        organizationId: string;
        uploadId: string;
        data: CompleteReportSampleUploadBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof completeReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: CompleteReportSampleUploadBody;
  },
  TContext
> => {
  return useMutation(
    getCompleteReportSampleUploadMutationOptions(options),
    queryClient
  );
};
